// extracted by mini-css-extract-plugin
export var actions = "_19-0";
export var actionsContainer = "_19-6";
export var border = "_19-1";
export var childFullHeight = "_19-d";
export var collapse = "_19-2";
export var content = "_19-8";
export var contentChild = "_19-c";
export var fullscreen = "_19-a";
export var headerContainer = "_19-3";
export var headerRow = "_19-5";
export var hidePadding = "_19-9";
export var noScrollX = "_19-e";
export var noScrollY = "_19-f";
export var optOutTopPadding = "_19-b";
export var pagePadding = "_19-7";
export var profile = "_19-g";
export var profileContainer = "_19-h";
export var profileImage = "_19-i";
export var profileMain = "_19-j";
export var profileSubtitle = "_19-l";
export var profileTitle = "_19-k";
export var tabsWrapper = "_19-4";
export var title = "_19-m";